import {
  Button,
  Card,
  Typography,
  Grid,
  withStyles,
  LinearProgress,
  Link,
  Chip,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { deepPurple } from '@material-ui/core/colors'
import StarRoundedIcon from '@material-ui/icons/StarRounded'
import { useRouter } from 'next/router'
import React from 'react'

import { Wallet, WalletType } from '../../../../types/wallet'
import { urls } from '../../../utils/config'
import { calculateAverageRating } from '../../../utils/wallet'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '40px auto',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    boxShadow: 'none',
    display: 'flex',
    borderRadius: '1rem',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    padding: '16px 24px',
    '@media (max-width: 420px)': {
      margin: '5px',
      padding: '20px',
    },
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '2rem',
    margin: '0 0',
  },
  logoContainer: {
    marginTop: '20px',
    marginBottom: '25px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    '@media (max-width: 420px)': {
      width: '100%',
      maxWidth: '100%',
      margin: '30px 0 0 0',
      justifyContent: 'flex-start',
    },
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 420px)': {
      justifyContent: 'center',
      flexBasis: '100%',
    },
  },
  logo: {
    maxHeight: '60px',
    width: 'auto',
    maxWidth: '60px',
    objectFit: 'contain',
    alignSelf: 'flex-start',
    marginRight: '25px',
    '@media (max-width: 420px)': {
      alignSelf: 'unset',
      maxHeight: '50px',
    },
  },
  description: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  leftSection: {
    width: '70%',
    '@media (max-width: 420px)': {
      width: '100%',
    },
  },
  rightSection: {
    width: '30%',
    '@media (max-width: 420px)': {
      width: '100%',
    },
  },
  descriptionSection: {
    marginBottom: '30px',
    paddingRight: '30px',
    '@media (max-width: 420px)': {
      padding: '0',
      margin: '20px auto',
      textAlign: 'center',
    },
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '25px',
    alignItems: 'center',
  },
  button: {
    marginTop: '20px',
    width: '204px',
    height: '64px',
    fontSize: '18px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  mobileButton: {
    marginTop: '20px',
    width: '204px',
    height: '64px',
    fontSize: '18px',
    display: 'none',
    '@media (max-width: 420px)': {
      margin: '20px auto',
      display: 'block',
    },
  },
  campaign: {
    color: theme.palette.primary.main,
    width: 'fit-content',
    position: 'relative',
    '& h5': {
      position: 'relative',
    },
    marginBottom: '20px',
    [theme.breakpoints.down('xs')]: {
      margin: '0 auto',
    },
  },
  campaignTitle: {
    fontSize: '18px',
  },
  campaignBackground: {
    position: 'absolute',
    top: '5px',
    left: '-5px',
    width: '110%',
    backgroundColor: theme.palette.secondary.main,
    height: '26px',
  },
  rating: {
    position: 'relative',
    fontSize: '.8rem',
    '@media (max-width: 420px)': {
      fontSize: '.8rem',
    },
  },
  ratingContainer: {
    width: '100%',
    '@media (max-width: 420px)': {
      margin: '20px auto',
      alignItems: 'baseline',
    },
  },
  ratingBackground: {
    position: 'absolute',
    top: '-10px',
    left: '10px',
    width: '150px',
    backgroundColor: theme.palette.secondary.main,
    height: '61px',
    '@media (max-width: 420px)': {
      width: '120px',
      height: '40px',
      top: '2px',
    },
  },
  hideMobile: {
    '@media (max-width: 420px)': {
      display: 'none',
    },
  },
  promotionSection: {
    position: 'relative',
    width: 'fit-content',
    margin: '20px 0',
  },
  promotion: {
    backgroundColor: deepPurple['400'],
    color: 'white',
    fontWeight: 'bold',
    position: 'relative',
    '@media (max-width: 420px)': {
      fontSize: '14px',
    },
  },
  promotionBackground: {
    position: 'absolute',
    top: '10px',
    left: '-5px',
    width: '90%',
    backgroundColor: theme.palette.secondary.main,
    height: '18px',
    '@media (max-width: 420px)': {
      top: '8px',
      height: '14px',
    },
  },
  feesContainer: {
    margin: '1rem 0',

    '& > p > span': {
      fontWeight: 'bold',
    },
  },
  actionSection: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '1rem 0',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '2rem',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: '0',
    },
    '& button': {
      margin: '0 1rem',
      textTransform: 'none',
      borderRadius: '1rem',
    },
    '& a': {
      fontSize: '.8rem',
      borderBottom: '1px solid black',
      margin: '0 1rem',
    },
  },
  sectionTitle: {
    fontWeight: 600,
  },
  sectionValue: {
    color: ' rgba(43, 24, 65, 1) !important',
    fontWeight: 600,
  },
}))

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 6,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[300],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}))(LinearProgress)

interface Props {
  wallet: Wallet
  type: WalletType
  hideFeature?: boolean
}

function WalletCard({ wallet, type, hideFeature }: Props): JSX.Element {
  const classes = useStyles({})
  const { push } = useRouter()
  let url = ''
  switch (type) {
    case WalletType.custodial:
      url = `${urls.custodialWallets}/${wallet.path_id}`
      break
    case WalletType.nonCustodial:
      url = `${urls.nonCustodialWallets}/${wallet.path_id}`
      break
    case WalletType.physical:
      url = `${urls.physicalWallets}/${wallet.path_id}`
      break
    default:
      url = ''
      break
  }

  const goToReview = () => push(url)
  const averageRating = calculateAverageRating(wallet)
  return (
    <Card className={classes.root}>
      {!hideFeature && wallet.campaign && (
        <div className={classes.campaign}>
          <Chip label={wallet.campaign.title} color="primary" icon={<StarRoundedIcon />} />
        </div>
      )}
      <div className={classes.mainSection}>
        <div className={classes.logoContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <img
                width={320}
                height={320}
                src={`${wallet.icon && wallet.icon.url}`}
                className={classes.logo}
                alt={`${wallet.title} logo`}
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <div className={classes.titleContainer}>
                <Typography variant="h3" className={classes.title}>
                  {wallet.title}
                </Typography>
              </div>
              {averageRating && (
                <Grid
                  className={classes.ratingContainer}
                  item
                  container
                  justify="center"
                  alignItems="center"
                  xs={12}
                  md={8}
                  spacing={1}
                >
                  <Grid item xs={12} md={8}>
                    <BorderLinearProgress variant="determinate" value={(averageRating / 5) * 100} />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="h3" className={classes.rating}>
                      {averageRating.toFixed(1)} out of 5
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {wallet.fees?.europe && type === WalletType.custodial && (
                <div className={classes.feesContainer}>
                  <Typography variant="body2" className={classes.sectionTitle}>
                    Buy Fees / Sell Fees :
                    <span>
                      {wallet.fees?.europe?.fees['bank']?.buy} /{' '}
                      {wallet.fees?.europe?.fees['bank']?.sell}
                    </span>
                  </Typography>
                </div>
              )}
              {wallet.short_description && (
                <div className={`${classes.descriptionSection} ${classes.hideMobile}`}>
                  <Typography color="textSecondary" className={classes.description}>
                    {wallet.short_description}
                  </Typography>
                </div>
              )}
              {wallet.best_thing && (
                <div className={classes.descriptionSection}>
                  <Typography variant="body2" className={classes.sectionTitle}>
                    The best thing
                  </Typography>
                  <Typography color="textSecondary" className={classes.description}>
                    {wallet.best_thing}
                  </Typography>
                </div>
              )}
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body2" className={classes.sectionTitle}>
                      Assets
                    </Typography>
                    <Typography className={classes.sectionValue}>
                      {wallet.cryptocurrencies.map(
                        (currency, index, currencies) =>
                          `${currency.name}${index < currencies.length - 1 ? ', ' : '.'}`,
                      )}
                    </Typography>
                  </Grid>
                  {type === WalletType.custodial && (
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2" className={classes.sectionTitle}>
                        Payment Methods
                      </Typography>
                      <Typography className={classes.sectionValue}>
                        {wallet.paymentmethods.map(
                          (method, index, methods) =>
                            `${method.name}${index < methods.length - 1 ? ', ' : '.'}`,
                        )}
                      </Typography>
                    </Grid>
                  )}
                  {type === WalletType.physical && wallet.integrations && (
                    <Grid item xs={12} md={6}>
                      <Typography variant="body2" className={classes.sectionTitle}>
                        Integrations
                      </Typography>
                      <Typography className={classes.sectionValue}>
                        {wallet.integrations}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.infoSection}>
          {wallet.promotion && (
            <div className={classes.promotionSection}>
              <Chip
                label={wallet.promotion}
                className={classes.promotion}
                icon={<StarRoundedIcon style={{ color: 'white' }} />}
              />
            </div>
          )}
          <div className={classes.actionSection}>
            <Link underline="none" href={url} color="inherit">
              Learn more about {wallet.title}
            </Link>
            <Button
              variant="contained"
              color="primary"
              target="_blank"
              href={wallet.url}
              disableElevation
            >
              Try {wallet.title} now!
            </Button>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default WalletCard
